<template>
    <el-dialog
            class="dealerDialog"
            title="选择经销商"
            :visible="true"
            :append-to-body=true
            width="60%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="经销商编号:">
                <el-input v-model="form.dealer_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="经销商名称:">
                <el-input v-model="form.dealer_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="关键词:">
                <el-input v-model="form.keywords" clearable placeholder="手机号、负责人"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getDealer('search')">搜索</el-button>
            </el-form-item>
        </el-form>
        <span>提示：经销商资料请在【客户】-【经销商管理】中添加、管理</span>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                style="margin: 20px 0">
            <el-table-column
                    prop="dealer_sn"
                    label="经销商编号"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="dealer_name"
                    label="经销商名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="level_name"
                    label="经销商级别"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="person"
                    label="负责人"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>
    </el-dialog>
    
</template>

<script>
    export default {
        name: "selectDealer",
        data () {
            return {
                loading:false,
                form: {
                    dealer_sn:'',
                    dealer_name:'',
                    keywords:'',
                },
                tableData: [],
                stockArray: [],//仓库
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
            }
        },
        methods:{
            getDealer(temp){
                let data={}
                if(temp){
                        data={
                            lang: '',
                            dealer_sn: this.form.dealer_sn,
                            dealer_name: this.form.dealer_name,
                            keywords:this.form.keywords,
                        }
                }else{
                     data={
                            lang: '',
                            dealer_sn: this.form.dealer_sn,
                            dealer_name: this.form.dealer_name,
                            keywords:this.form.keywords,
                            per_page: this.pageSize,
                            page: this.pageNo
                        }
                }
                this.loading = true;
                this.$get('logistics', '/dealers', data).then(res => {
                    this.loading = false;
                    //console.log(res);
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;

                    console.log(error);
                });
            },
            //选择经销商
            choose(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getDealer();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getDealer();
            },
            handleClose(){
                this.$emit('handleClose');
            },

        },
        created(){
            this.getDealer();

        }
    }
</script>

<style lang="scss" scoped>


</style>